import { Button, Grid, Typography } from '@mui/material';
import Iconify from '../../components/iconify';
import { FilterAutocomplete } from '../Report/components/ui';

export const FilterSectionComponent = ({
  selectedYear,
  selectedQuarter,
  handleYearChange,
  handleQuarterChange,
  isAdminFlag,
  handleAddGoal,
  addButtonShow = false,
}) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const years = Array.from({ length: currentYear - 2020 + 1 }, (_, index) => 2020 + index);
  const quarters = [
    { value: 'Q1', label: 'Q1 (January - March)' },
    { value: 'Q2', label: 'Q2 (April - June)' },
    { value: 'Q3', label: 'Q3 (July - September)' },
    { value: 'Q4', label: 'Q4 (October - December)' },
  ];
  return (
    <Grid container direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ mt: 2 }}>
      <Grid item container direction="row" alignItems="center" justifyContent="flex-start" xs={addButtonShow ? 9 : 12}>
        <Grid item container direction="row" alignItems="center" justifyContent="flex-start" gap={1} xs={6}>
          <Grid item xs={1}>
            <Typography>Year:</Typography>
          </Grid>
          <Grid item xs={10}>
            <FilterAutocomplete
              value={selectedYear}
              disableClearable
              onChange={handleYearChange}
              options={years}
              multiple={false}
              fullWidth
              getOptionLabel={(option) => String(option)}
              renderOption={(props, option) => (
                <li style={{ textTransform: 'capitalize' }} {...props}>
                  {option}
                </li>
              )}
            />
          </Grid>
        </Grid>
        <Grid item container direction="row" alignItems="center" justifyContent="flex-start" gap={3.5} xs={6}>
          <Grid item xs={1}>
            <Typography>Quarter:</Typography>
          </Grid>
          <Grid item xs={10}>
            <FilterAutocomplete
              value={quarters.find((q) => q.value === selectedQuarter)} // Match the selected quarter object
              disableClearable
              onChange={handleQuarterChange}
              multiple={false}
              options={quarters}
              fullWidth
              getOptionLabel={(option) => option.label}
              renderOption={(props, option) => (
                <li style={{ textTransform: 'capitalize' }} {...props}>
                  {option.label}
                </li>
              )}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item container justifyContent="flex-end" xs={3}>
        {isAdminFlag && addButtonShow && (
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleAddGoal} size="large">
            Add Another Quarter Goal
          </Button>
        )}
      </Grid>
    </Grid>
  );
};
